import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
// import iView from 'iview'
import routes from './routes'
import Cookies from 'js-cookie'
import utilsTools from '@/libs/utils.js';
// Vue.use(iView)
Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({y: 0}),
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if (document.documentElement.clientWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  }
  let lock = Cookies.get('lock')
  if (to.meta.requiresAuth) {
    let token = utilsTools.getStorage("_access_token")
    if (token != null && token !== undefined) {
      store.dispatch('getCurrentPageName', to.meta.title)
      if (lock === '1') {
        console.log('lock', lock)
        next({
          path: '/lock'
        })
      } else {
        next()
      }
    } else {
      next({
        path: '/login',
        query: {redirect: '/index'}
      })
    }
  } else {
    store.dispatch('getCurrentPageName', to.name)
    next()
  }
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js